import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Input, Space, Drawer, Form, Select, Modal } from "antd";
import { message } from "../../components/antdMessageBridge";
import { CloseCircleOutlined } from "@ant-design/icons";
import Html5QrcodePlugin from "../qrscanner/qrscanner";
import { Html5QrcodeScanType } from "html5-qrcode";
import regexService, { removeSpaces } from "../../components/commonregex/regexService";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import CommonObj from "../../CommonObj";

const { Option } = Select;

const IntakeRejectSlide = (props) => {
    const [form] = Form.useForm();
    const [activeScanner, setActiveScanner] = useState(null);
    const [decodedResults, setDecodedResults] = useState([]);
    const [, setForm1] = useState({});
    const [regexLoaded, setRegexLoaded] = useState(false);

    const { accessToken } = useAuthToken();
    const [loading, setLoading] = useState(false);
    const [rejectionOptions, setRejectOptions] = useState([]);
    const [error, setError] = useState(null);

    const getScannerTrackLabel = () => {
        if (props.title === "Intake Reject") return "intake";
        if (props.title === "QC Reject") return "qc";
        if (props.title === "Cutting Reject") return "cutting";
        return "general";
    };

    function filterUniqueScans(results) {
        const filteredResults = [];
        if (results.length === 0) {
            return filteredResults;
        }
        filteredResults.push(results[0]);
        for (let i = 1; i < results.length; ++i) {
            if (results[i].decodedText !== results[i - 1].decodedText) {
                filteredResults.push(results[i]);
            }
        }
        return filteredResults;
    }
    const fetchRejectionData = async () => {

        setLoading(true);
        try {
            const myHeaders = {
                "Authorization": `Bearer ${accessToken}`,
                "X-CSRF-Token": encryptTimestamp(),
            };
            const formData = new FormData();
            formData.append('statusName',
                props.title === "Intake Reject" ? 'Intake - Reject' :
                    props.title === "QC Reject" ? 'QC - Reject' :
                        'Cutting - Reject'
            ); const response = await fetch(CommonObj.Endpoints.GetRejectReasonsMaster, {
                method: 'POST',
                headers: myHeaders,
                body: formData
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const result = await response.json();
            const books = Array.isArray(result) ? result : [result];
            setRejectOptions(books);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    const handleCancel = () => {
        props?.setIsModalVisible(false);
        form.resetFields();
    };
    useEffect(() => {
        fetchRejectionData();

    }, []);

    useEffect(() => {
        const loadRegexPatterns = async () => {
            try {
                await regexService.fetchRegexData(accessToken);
                setRegexLoaded(true);
            } catch (error) {
                console.error("Failed to load regex patterns", error);
            }
        };

        if (accessToken) {
            loadRegexPatterns();
        }
    }, [accessToken]);

    useEffect(() => {
        const uniqueResults = filterUniqueScans(decodedResults);

        if (uniqueResults.length > 0 && activeScanner) {
            const latestResult = uniqueResults[uniqueResults.length - 1];
            const scannedValue = latestResult.decodedText;

            switch (activeScanner) {
                case "ISBN":
                    setForm1((prev) => ({ ...prev, isbn: scannedValue }));
                    break;
                case "BID":
                    setForm1((prev) => ({ ...prev, bid: scannedValue }));
                    break;
                case "Rack & Shelf ID":
                    setForm1((prev) => ({ ...prev, rackAndShelf: scannedValue }));
                    form.setFieldsValue({
                        rackAndShelf: scannedValue,
                    });
                    break;
                case "New Rack & Shelf ID":
                    delete form?.NrackAndShelf;
                    setForm1((prev) => ({ ...prev, NrackAndShelf: scannedValue }));
                    form.setFieldsValue({
                        rackAndShelf: scannedValue,
                    });
                    break;
                default:
                    break;
            }
            setActiveScanner(null);
            setDecodedResults([]);
        }
    }, [decodedResults, activeScanner]);

    function cusfun(e) {
        e.preventDefault();
    }

    const onNewScanResult = (decodedText, decodedResult) => {
        setDecodedResults((prev) => [...prev, decodedResult]);
    };

    const validateRackShelf = (_, value) => {
        if (!value) {
            return Promise.reject(new Error("Rack and Shelf is required."));
        }
if (props.title !== "Intake Reject") {
    if (value && removeSpaces(value).toLowerCase() === removeSpaces(props?.oldRackandShelf).toLowerCase()) {
        return Promise.reject(
            new Error("Books sent for rework cannot be placed in the same rack. Please scan the new rack.")
        );
    }
}
        if (value && regexLoaded) {
            const validation = regexService.validateRackShelf(value.trim());
            if (!validation.isValid) {
                return Promise.reject(
                    new Error("Input format invalid: No matching pattern found.")
                );
            }
        }

        return Promise.resolve();
    };



    const handleReject = async (key) => {
        try {
            const loadingKey = 'rejecting';
            const payload = props.rejectSubmissionData;
            payload.rejectReasonId = key.rejectionReason;
            payload.rejectRackShelf = key.rackAndShelf;


            const myHeaders = {
                "Authorization": `Bearer ${accessToken}`,
                "X-CSRF-Token": encryptTimestamp(),
                'Content-Type': 'application/json'
            };
            const endpointMap = {
                "Intake Reject": CommonObj.Endpoints.SaveIntakeRejectBookDetails,
                "Cutting Reject": CommonObj.Endpoints.SaveCuttingRejectBookDetails,
                "QC Reject": CommonObj.Endpoints.SaveQcRejectBookDetails
            }; const targetEndpoint = endpointMap[props.title] || CommonObj.Endpoints.SaveIntakeRejectBookDetails;
            const response = await fetch(targetEndpoint, {
                method: 'POST',
                headers: myHeaders,
                body: JSON.stringify(payload),
            });

            let resReject = await response.json()
            if (!response.ok) {
            const errorMessage = resReject.error || resReject.message || `Error ${response.status}`;
            throw new Error(errorMessage);
    }
            if (resReject.status === false) {
                message.error(resReject.message || "Failed to reject the book(s).", 5);
                return
            }

            message.success({ content: 'Book(s) has been rejected successfully!', key: loadingKey, duration: 2 });
            handleCancel();
            props.clearForm();
        } catch (error) {
            console.error('API Error:', error);
            message.error({ content: error.message, duration: 5 });
        }
    };

    return (
        <>
            <Modal
                title={`Scan ${activeScanner ? activeScanner : ""}`}
                open={!!activeScanner}
                onCancel={() => setActiveScanner(null)}
                footer={null}
                destroyOnClose
                className="scan-model-container"
            >
                <div className="scan-modal">
                    <Html5QrcodePlugin
                        fps={30}
                        qrbox={{ width: 1000, height: 400 }}
                        aspectRatio={2.8}
                        disableFlip={false}
                        qrCodeSuccessCallback={onNewScanResult}
                        supportedScanTypes={[Html5QrcodeScanType.SCAN_TYPE_CAMERA]}
                    />
                </div>
            </Modal>
            <Drawer
                title={
                    <span>
                        <span>{props.title}</span>{" "}
                    </span>
                }
                open={props.isModalVisible}
                onCancel={handleCancel}
                onClose={handleCancel}
                footer={null}
                closeIcon={<CloseCircleOutlined />}
                className={props.className}
                width={props.width}
            >
                <div className="modal-body">
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleReject}
                        initialValues={""}
                    >
                        {/*<Form.Item*/}
                        {/*    name="bidId"*/}
                        {/*    label="Bid ID"*/}
                        {/*    hidden*/}
                        {/*>*/}
                        {/*    <Input />*/}
                        {/*</Form.Item>*/}
                        {/* <Form.Item
                            name="rejectionReason"
                            label="Rework Reason"
                            rules={[{ required: true, message: "Please provide a Reason!" }]}
                            className="rejection-reason-slider"
                        >
                            <TextArea rows={3} className="book-page-form-input-textarea" />
                        </Form.Item> */}
                        <Form.Item
                            name="rejectionReason"
                            label="Reject Reason"
                            rules={[{ required: true, message: "Please provide a Reason!" }]}
                            className="rejection-reason-slider"
                        >
                            <Select placeholder="Select a Reason" notFoundContent="No Rejection Reasons Available">
                                {rejectionOptions.map((option) => (
                                    <Option key={option.id} value={option.id}>
                                        {option.reason}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <label className="form-label">
                            Scan Rack Shelf<span className="form-required-rack">*</span>
                        </label>
                        <div className="book-page-form-scan-rack-container modal-scan-rack  bgColor span2column">
                            <Form.Item
                                name="rackAndShelf"
                                rules={[
                                    {
                                        validator: validateRackShelf,
                                    },
                                ]}
                                className="book-page-form-scan-rack-button"
                            >
                                <Input placeholder="Enter / Scan Rack Shelf Barcode"></Input>
                            </Form.Item>
                            <Form.Item name="submit" hidden></Form.Item>
                            <button
                                className="book-page-form-scan-rack-button-icon"
                                htmlType="submit"
                                data-track={`books-${getScannerTrackLabel()}-open-rack-scanner`}
                                onClick={(event) => {
                                    setDecodedResults([]);
                                    setActiveScanner("Rack & Shelf ID");
                                    cusfun(event);
                                }}
                            >
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="12"
                                        cy="13"
                                        r="3"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M10.0001 20H14.0001C16.809 20 18.2135 20 19.2224 19.3259C19.6591 19.0341 20.0341 18.6591 20.326 18.2223C21.0001 17.2134 21.0001 15.8089 21.0001 13C21.0001 10.1911 21 8.78685 20.3258 7.77795C20.034 7.34119 19.659 6.96619 19.2222 6.67436C18.2133 6.00023 16.8089 6.00023 14 6.00023H9.99995C7.19103 6.00023 5.78656 6.00023 4.77767 6.67436C4.34091 6.96619 3.96591 7.34119 3.67407 7.77795C3.0001 8.78663 3.0001 10.1905 3.0001 12.9982L3.0001 13C3.0001 15.8089 3.0001 17.2134 3.67422 18.2223C3.96605 18.6591 4.34106 19.0341 4.77782 19.3259C5.78671 20 7.19117 20 10.0001 20Z"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        d="M18 10H17.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M14.5 3.5H9.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                                <svg
                                    width="20"
                                    height="18"
                                    viewBox="0 0 20 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M6.00098 1C6.00098 0.447715 6.41425 0 6.92405 0H13.0779C13.5877 0 14.001 0.447715 14.001 1C14.001 1.55228 13.5877 2 13.0779 2H6.92405C6.41425 2 6.00098 1.55228 6.00098 1Z"
                                        fill="url(#paint0_linear_2146_40101)"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M7.77875 18H12.2232C15.3442 18 16.9047 18 18.0257 17.2777C18.511 16.965 18.9277 16.5632 19.252 16.0953C20.001 15.0143 20.001 13.5095 20.001 10.4999C20.001 7.49027 20.0008 5.9857 19.2518 4.90473C18.9275 4.43676 18.5109 4.03497 18.0256 3.72228C16.9046 3 15.3441 3 12.223 3H7.77859C4.65756 3 3.09705 3 1.97605 3.72228C1.49077 4.03497 1.0741 4.43676 0.749835 4.90473C0.000976503 5.98547 0.000976526 7.48961 0.000976563 10.4979L0.000976563 10.4999C0.000976563 13.5095 0.000976622 15.0143 0.750001 16.0953C1.07426 16.5632 1.49093 16.965 1.97622 17.2777C3.09721 18 4.65773 18 7.77875 18ZM5.83431 10.4999C5.83431 8.28085 7.69979 6.48196 10.001 6.48196C12.3022 6.48196 14.1676 8.28085 14.1676 10.4999C14.1676 12.7189 12.3022 14.5178 10.001 14.5178C7.69979 14.5178 5.83431 12.7189 5.83431 10.4999ZM7.50098 10.4999C7.50098 9.16846 8.62027 8.08913 10.001 8.08913C11.3817 8.08913 12.501 9.16846 12.501 10.4999C12.501 11.8313 11.3817 12.9106 10.001 12.9106C8.62027 12.9106 7.50098 11.8313 7.50098 10.4999ZM16.1121 6.48196C15.6519 6.48196 15.2788 6.84174 15.2788 7.28554C15.2788 7.72935 15.6519 8.08913 16.1121 8.08913H16.6676C17.1279 8.08913 17.501 7.72935 17.501 7.28554C17.501 6.84174 17.1279 6.48196 16.6676 6.48196H16.1121Z"
                                        fill="url(#paint1_linear_2146_40101)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_2146_40101"
                                            x1="20.601"
                                            y1="8.95028"
                                            x2="-0.0170404"
                                            y2="11.3301"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                        <linearGradient
                                            id="paint1_linear_2146_40101"
                                            x1="20.601"
                                            y1="8.95028"
                                            x2="-0.0170404"
                                            y2="11.3301"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                            <span className="error-msg-rad"></span>
                        </div>
                        <div className="modal-footer">
                            <Form.Item className="model-action-container">
                                <Space>
                                    <button
                                        className="cancel-button-gray-outline"
                                        type="button"
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="submit-button-red-outline"
                                        htmlType="submit"
                                        onClick={() => handleReject}
                                    >
                                        Submit for Reject
                                    </button>
                                </Space>
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            </Drawer>
        </>
    );
};

IntakeRejectSlide.propTypes = {
    selectedRowKeys: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    ),
    isModalVisible: PropTypes.bool.isRequired,
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
};

IntakeRejectSlide.defaultProps = {
    selectedRowKeys: [],
    className: "",
    width: 500,
    title: "",
    isModalVisible: false
};

export default IntakeRejectSlide;